import { Button } from "@mui/material";
import React from "react";
import { COLORS } from "components/Pricing/constants";
import { Plan } from "components/Pricing/types";

declare var fbq: (...args: any[]) => void;

const trackAndGo = (plan: Plan, e?: React.MouseEvent) => {
  if (!plan.buttonUrl) return;

  if (typeof fbq !== "undefined") {
    fbq("trackCustom", "PricingButtonClick", {
      tierId: plan.id,
      tierTitle: plan.title,
    });
  }

  if (e) e.preventDefault();
  setTimeout(() => {
    window.location.href = plan.buttonUrl!;
  }, 150);
};

type SelectButtonProps = {
  plan: Plan;
};

export const SelectButton = ({ plan }: SelectButtonProps) => {
  if (!plan.buttonText || !plan.buttonVariant || !plan.buttonUrl) return null;

  return (
    <Button
      id={plan.id}
      href={plan.buttonUrl}
      variant={plan.buttonVariant}
      onClick={(e) => trackAndGo(plan, e)}
      sx={{
        minWidth: 120,
        backgroundColor: plan.buttonVariant === "contained" ? COLORS.cta : "transparent",
        color: plan.buttonVariant === "contained" ? "white" : COLORS.cta,
        borderColor: COLORS.cta,
        textTransform: "none",
        fontWeight: 800,
        borderRadius: 999,
        "&:hover": {
          backgroundColor:
            plan.buttonVariant === "contained" ? COLORS.ctaHover : "rgba(90, 47, 158, 0.1)",
        },
      }}
    >
      {plan.buttonText}
    </Button>
  );
};
